
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DocumentCollaborationParameter, DocumentParameterContainer } from "../../../domain/document";

@Component
export default class DocumentParameterContainableMixin extends Mixins() {
  @Prop()
  problemNo: string;

  get parameterContainer(): DocumentParameterContainer {
    const container = new DocumentParameterContainer();
    container.collaborationParameter = this.createDocumentCollaborationParameter();
    return container;
  }

  private createDocumentCollaborationParameter(): DocumentCollaborationParameter {
    if (!this.$configuration.behavior.document.editor.collaboration.shouldRegisterCollaborationParameter) {
      return null;
    }
    const collaborationParameter = new DocumentCollaborationParameter();
    collaborationParameter.problemNo = this.problemNo;
    if (this.$store.getters.orderUser) {
      collaborationParameter.orderUserCode = this.$store.getters.orderUser.id;
    }
    // 値が無いときは不要
    return collaborationParameter.hasValue()
      ? collaborationParameter
      : null;
  }
}
